import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import Routes from './containers/routes'
import { initAnalytics } from './analytics'
import './tailwind.css'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import Snackbar from './components/atoms/Snackbar'

// Intializing the analytics
initAnalytics()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <Routes />
    <Snackbar />
    {/* </React.StrictMode> */}
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
